import { Input, Spin, Space, Button, Checkbox, Divider } from "antd";
import { useEffect, useRef, useState } from "react";
import { ZupRole } from "./role.type";
import { useLazyGetZupRolesQuery } from "../../../store/api/roleApi";

interface Props {
    selectedKeys: string[];
    setSelectedKeys: (keys: string[]) => void;
    confirm: () => void;
    clearFilters: () => void;
}

const ZupRoleFilterDropdown = ({ selectedKeys, setSelectedKeys, confirm, clearFilters }: Props) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [options, setOptions] = useState<ZupRole[]>([]);
    const [totalElements, setTotalElements] = useState<number>(0);

    const [trigger, { isFetching }] = useLazyGetZupRolesQuery();

    const loadData = async (pageToLoad: number, search: string) => {
        try {
            const res = await trigger({
                page_number: pageToLoad,
                page_size: 10,
                name: search || undefined,
                enabled: true
            }).unwrap();

            const newItems = res.data.content;

            setOptions(prev => {
                if (pageToLoad === 1) return newItems;

                const existingIds = new Set(prev.map(item => item.id));
                const filteredNewItems = newItems.filter(item => !existingIds.has(item.id));

                return [...prev, ...filteredNewItems];
            });

            setTotalElements(res.data.total_elements);
        } catch (e) {
            console.error("Ошибка загрузки ролей:", e);
        }
    };

    useEffect(() => {
        setPage(1);
        loadData(1, searchTerm);
    }, [searchTerm]);

    useEffect(() => {
        if (page > 1) {
            loadData(page, searchTerm);
        }
    }, [page]);

    const handleScroll = () => {
        if (!containerRef.current || isFetching) return;
        const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
        if (scrollTop + clientHeight >= scrollHeight - 10 && options.length < totalElements) {
            setPage(prev => prev + 1);
        }
    };

    const handleCheckboxChange = (id: string, checked: boolean) => {
        if (checked) {
            setSelectedKeys([...selectedKeys, id]);
        } else {
            setSelectedKeys(selectedKeys.filter(key => key !== id));
        }
    };

    return (
        <div style={{ padding: 8, width: 500 }}>
            <Input
                placeholder="Поиск"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                allowClear
                style={{ marginBottom: 8 }}
            />
            <div
                ref={containerRef}
                onScroll={handleScroll}
                style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 8 }}
                className="ant-dropdown-menu"
            >
                <Space direction="vertical" style={{ width: '100%' }}>
                    {options.map((item) => (
                        <div
                            key={item.id}
                            className="ant-dropdown-menu-item"
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            <Checkbox
                                checked={selectedKeys.includes(item.id)}
                                onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
                            >
                                {item.name}
                            </Checkbox>
                        </div>
                    ))}
                    {isFetching && <Spin size="small" style={{ padding: 8, textAlign: 'center' }} />}
                </Space>
            </div>
            <Divider style={{ margin: "8px 0" }} />
            <Space>
                <Button
                    onClick={() => {
                        clearFilters();
                        setSearchTerm('');
                    }}
                    size="small"
                >
                    Сбросить
                </Button>
            </Space>
        </div>
    );
};

export default ZupRoleFilterDropdown;
